import { FC, Fragment } from "react";
import { CustomerWithUserCustomers } from "../../../api/models/CustomerWithUserCustomers";
import { NestedTableRow, NestedTableColumn } from "../table/tableComponents";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";
import OrganizationCustomerItem from "../../../features/organizations/components/organizationCustomerItem";

export interface NestedOrganizationCustomerViewProps {
    activeTab: string;
    customers: CustomerWithUserCustomers[] | undefined;
}
const NestedOrganizationCustomerView: FC<NestedOrganizationCustomerViewProps> = (props) => {
    const { t } = useCustomTranslation();

    return (
        /*<td colSpan={10}>
            <table>
                <tbody>
                    {props.customers && props.customers.length > 0 ?
                        <Fragment>
                            {props.customers.map(customer => (
                                <OrganizationCustomerItem customer={customer} key={customer.id} activeTab={props.activeTab} />
                            ))}
                        </Fragment>
                        : <Fragment>
                            <NestedTableRow>
                                <NestedTableColumn>{t("No customers found")}</NestedTableColumn>
                            </NestedTableRow>
                        </Fragment>}
                </tbody>
            </table>
        </td>*/
        <>
            {props.customers && props.customers.length > 0 ?
                <Fragment>
                    {props.customers.map(customer => (
                        <OrganizationCustomerItem customer={customer} key={customer.id} activeTab={props.activeTab} />
                    ))}
                </Fragment>
                : <Fragment>
                    <NestedTableRow>
                        <NestedTableColumn>{t("No customers found")}</NestedTableColumn>
                    </NestedTableRow>
                </Fragment>
            }
        </>
    )
}

export default NestedOrganizationCustomerView;